export default __webpack_public_path__ + "static/1322-e102e6a28da44fb9d28461bb1f17c5c5.gif";